import React from 'react';
import type { FC } from 'react';
import { DevCommandScreen } from './DevCommandScreen.js';
import { DevEnvironmentProvider } from './DevEnvironment.js';

export const DevCommand: FC<{ useTunnel: boolean }> = ({ useTunnel }) => {
  return (
    <DevEnvironmentProvider useTunnel={useTunnel}>
      <DevCommandScreen />
    </DevEnvironmentProvider>
  );
};
